<template>
	<v-row>
		<v-col class="mb-3 pb-0" cols="auto">
			<template v-if="hasTitle">
				<slot name="title"></slot>
			</template>
			<template v-else>
				<component :is="tag">{{ title }}</component>
			</template>
			<template v-if="hasContent && contentTag">
				<slot></slot>
			</template>
			<template v-else>
				<p v-if="hasContent">
					<slot></slot>
				</p>
			</template>
			<template v-if="caption">
				<p class="caption mt-n2">{{ caption }}</p>
			</template>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'FormSubsection',
	props: {
		caption: {
			type: String,
			default: ''
		},
		tag: {
			type: String,
			default: 'h6'
		},
		title: {
			type: String,
			default: 'Form Subsection Title'
		}
	},
	data() {
		return {
			contentTag: undefined,
			hasContent: false,
			hasTitle: false
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.hasContent = !!this.$slots?.default;
			this.hasTitle = !!this.$slots?.title;
			this.contentTag = this.hasContent && this.$slots?.default[0]?.tag;
		});
	}
};
</script>
